<template>
    <v-container class="mt-4 pa-0">
        <v-card color="primary" class="elevation-1 mx-auto" :style="{ height: '85vh', width: '80vw' }">
            <v-toolbar color="primary" flat>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-toolbar-side-icon v-on="on" @click="reset()" icon>
                            <v-icon>arrow_back</v-icon>
                        </v-toolbar-side-icon>
                    </template>
                    <span>Return to List</span>
                </v-tooltip>
                <h2>
                    <a target="new"
                        :href="`https://ops.bohmtech.com/web#id=${allQuants[0].product_id[0]}&view_type=form&model=product.product`"
                        :style="{ color: '#F04E23', textDecoration: 'none' }" class="ml-2">{{ allQuants[0].product_id[1]
                        }}</a>
                </h2>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-divider class="my-4"></v-divider>

            <div :style="{ height: '80%', overflow: 'scroll' }">
                <v-card color="primary elevation-0">
                    <v-card-text>
                        <h3 class="mb-0">Locations</h3>
                        <p class="mt-1 mb-0">The following locations were found with the product. Please count the total
                            pieces across all locations.</p>
                    </v-card-text>
                    <v-card-text>
                        <div v-for="(loc, index) in uniqueLocations" :key="loc.id">
                            <h3 class="ma-2">{{ index + 1 }}. {{ loc.name }}</h3>
                        </div>
                    </v-card-text>

                    <v-card-text>
                        <v-text-field v-model="totalCounted" box color="secondary" :label="`How many pieces across all locations?`"
                            @keyup="$forceUpdate()" type="tel" mask="######" />
                        <v-btn color="success" class="ml-4" @click="submitResults()"
                            :disabled="!totalCounted">Submit</v-btn>
                    </v-card-text>
                </v-card>
            </div>
        </v-card>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SerialDialog from "@/components/inventory/SerialDialog";
import LoginCheck from "@/mixins/LoginCheck";

export default {
    name: "InventoryEval",

    data() {
        return {
            currentProduct: null,
            allQuants: [{
                location_id: [0, ""],
                product_id: [0, ""],
                quantity: 0
            }],
            totalCounted: null
        };
    },

    mixins: [LoginCheck],

    components: {
        SerialDialog
    },

    async beforeMount() {
        this.allQuants = await this.searchQuant([
            {
                field: "product_id",
                operator: "=",
                value: parseInt(this.$route.params.id)
            },
            {
                field: "location_id.complete_name",
                operator: "ilike",
                value: 'repair'
            }
        ]);
        this.currentProduct = parseInt(this.$route.params.id);


        await this.getSettings("inventory");
    },

    watch: {
        quants: {
            async handler() {
                await this.getTracking();
            },
            deep: true
        }
    },

    computed: {
        ...mapGetters({

            user: "app/getUser",
            products: "productTemplate/getProduct",
            storedType: "inventory/getSearchType",
            settings: "settings/getSettings",
            filters: "inventory/getFilters"
        }),

        uniqueLocations() {
            const map = new Map()

            this.allQuants.forEach(q => {
                const [id, name] = q.location_id
                if (!map.has(id)) {
                    map.set(id, name)
                }
            })

            return Array.from(map, ([id, name]) => ({ id, name }))
        }

    },

    methods: {
        ...mapActions({
            searchQuant: "inventory/searchQuant",
            createException: "inventory/createException",
            updateEvalDate: "inventory/updateEvalDate",
            searchProduct: "productTemplate/search",
            getSettings: "settings/getSettings",
            loadLocations: "inventory/searchLocations",
        }),

        reset() {
            this.$router.push("/inventory");
        },


        async submitResults() {
            try {
                const body = {
                    location: this.allQuants[0].location_id,
                    product: this.allQuants[0].product_id,
                    evalBy: this.user.displayName,
                    correctValue: this.allQuants.reduce((acc, quant) => acc + quant.quantity, 0),
                    enteredValue: parseInt(this.totalCounted),
                }
                if (parseInt(this.totalCounted) != this.allQuants.reduce((acc, quant) => acc + quant.quantity, 0)) {
                    body['state'] = 'waiting'

                    await this.createException(body);


                    this.$store.dispatch("app/setSnackbar", {
                        text: "Results submitted successfully",
                        color: "green"
                    });

                    await this.updateEvalDate(this.currentProduct);
                    await this.loadLocations({
                        type: this.storedType,
                        limit: this.getLimit()
                    });
                    this.$router.push("/inventory");
                } else {
                    body['state'] = 'correct'
                    await this.createException(
                        body
                    );
                    this.$store.dispatch("app/setSnackbar", {
                        text: "Results submitted successfully",
                        color: "green"
                    });

                    await this.updateEvalDate(this.currentProduct);
                    await this.loadLocations({
                        type: this.storedType,
                        limit: this.getLimit()
                    });
                    this.$router.push(`/inventory`);
                    this.$store.dispatch("app/setSnackbar", {
                        text: "Evaluation Complete",
                        color: "green"
                    });
                }

            } catch (error) {
                this.$store.dispatch("app/setSnackbar", {
                    text: error.message,
                    color: "red"
                });
            }
        },

        getLimit() {
            let limit = this.settings.filter(setting => {
                return (
                    setting._id ===
                    this.filters.filter(filter => {
                        return filter.value === this.storedType;
                    })[0].settingID
                );
            })[0].value;

            return limit;
        },

        async handleNoInventory() {
            throw new Error("Not implemented");

            this.$router.push(`/inventory`);
            await this.updateEvalDate();
            await this.loadLocations({
                type: this.storedType,
                limit: this.getLimit()
            });
        },
    }
};
</script>
<style></style>
